import React from 'react';
import infoText from '../constants/info';

const localizedText = infoText['en-US'];

export const InfoSection = () => {
  return (
    <div className='info-container'>
      <div
        style={{
          display: 'inline-block',
        }}
      >
        <h3 className='table-preface'>
          {localizedText.header}
        </h3>
        {localizedText.paragraphs.map((text, i) => (
          <p key={`info-${i}`}>{text}</p>
        ))}
      </div>
    </div>
  );
};
